import { ExternalLink, Store } from 'lucide-react';
import { cn, storefrontProductUrl, shopifyAdminProductUrl } from '@/lib/utils';

interface ProductLinksProps {
  handle: string | null;
  shopifyProductId: number;
  /** Show text labels beside the icons — used where there's room (e.g. the detail header). */
  withLabels?: boolean;
  className?: string;
}

/**
 * Links out to a product on the storefront (dancingoaks.com) and in the
 * Shopify admin. One shared component — used by the Products list and the
 * product detail page so the links look and behave identically everywhere.
 */
export function ProductLinks({
  handle,
  shopifyProductId,
  withLabels = false,
  className,
}: ProductLinksProps) {
  const storefront = storefrontProductUrl(handle);
  const linkClass = cn(
    'inline-flex items-center gap-1.5 rounded-md text-muted-foreground transition-colors hover:text-primary',
    withLabels
      ? 'border border-border px-2.5 py-1 text-xs hover:bg-muted hover:text-foreground'
      : 'h-8 w-8 justify-center md:h-auto md:w-auto',
  );
  return (
    <div
      className={cn('flex items-center gap-2', className)}
      onClick={(e) => e.stopPropagation()}
    >
      {storefront && (
        <a
          href={storefront}
          target="_blank"
          rel="noopener noreferrer"
          title="View on dancingoaks.com"
          className={linkClass}
        >
          <ExternalLink className="h-3.5 w-3.5" />
          {withLabels && <span>Website</span>}
        </a>
      )}
      <a
        href={shopifyAdminProductUrl(shopifyProductId)}
        target="_blank"
        rel="noopener noreferrer"
        title="Edit in Shopify admin"
        className={linkClass}
      >
        <Store className="h-3.5 w-3.5" />
        {withLabels && <span>Shopify admin</span>}
      </a>
    </div>
  );
}
